import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-header mb-0" }, "Sobre")
], -1)
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "text-paragraph mb-0" }
const _hoisted_6 = {
  key: 0,
  class: "fa-solid fa-chevron-right ms-auto"
}
const _hoisted_7 = {
  key: 1,
  class: "text-muted text-paragraph mb-0 ms-auto"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          onClick: item.action,
          class: _normalizeClass(["d-flex align-items-center pb-4", {
          'cursor-pointer': item.action,
          'border-bottom': index + 1 != _ctx.items.length,
          'pt-4': index != 0,
        }]),
          key: index
        }, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(item.title), 1),
          (item.action)
            ? (_openBlock(), _createElementBlock("i", _hoisted_6))
            : _createCommentVNode("", true),
          (item.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(item.value), 1))
            : _createCommentVNode("", true)
        ], 10, _hoisted_4))
      }), 128))
    ])
  ]))
}